"use client";

import "@api/orpc.browser";
import { NuqsAdapter } from "nuqs/adapters/tanstack-router";

export function ClientBootstrap({ children }: { children: React.ReactNode }) {
  return <NuqsAdapter>{children}</NuqsAdapter>;
}
